import { ApiClientBase } from '../ApiClientBase';
export class WardApiClient extends ApiClientBase {
  private static instance: WardApiClient;
  /**
   * Singleton instance of WardApiClient
   */
  constructor() {
    super(import.meta.env.VITE_API_BASE_URL_LEGACY);
  }

  static getInstance(): WardApiClient {
    if (!this.instance) {
      this.instance = new WardApiClient();
    }
    return this.instance;
  }
}
